// src/pages/QuizPage/utils/quizStorage.ts
import type { CachedQuizState } from "./quizTypes";

const PREFIX = "quiz_";

function makeKey(mode: string, id?: string | number | null): string {
  return `${PREFIX}${mode}_${id ?? "default"}`;
}

export const quizStorage = {
  save(
    mode: string,
    id: string | number | null | undefined,
    data: CachedQuizState,
  ): void {
    try {
      sessionStorage.setItem(makeKey(mode, id), JSON.stringify(data));
    } catch {
      // quota exceeded — silent
    }
  },

  load(
    mode: string,
    id: string | number | null | undefined,
  ): CachedQuizState | null {
    try {
      const raw = sessionStorage.getItem(makeKey(mode, id));
      if (!raw) return null;
      const data = JSON.parse(raw);
      // Validation: bo'sh rawQs cache'ni qaytarmaymiz
      if (!data.rawQs?.length) {
        sessionStorage.removeItem(makeKey(mode, id));
        return null;
      }
      return data as CachedQuizState;
    } catch {
      try {
        sessionStorage.removeItem(makeKey(mode, id));
      } catch {}
      return null;
    }
  },

  clear(mode: string, id: string | number | null | undefined): void {
    try {
      sessionStorage.removeItem(makeKey(mode, id));
    } catch {}
  },

  clearMarafonLeftover(): void {
    try {
      sessionStorage.removeItem(`${PREFIX}marafon_undefined`);
    } catch {}
  },
};
